import Helmet from 'react-helmet';
import type { ReactNode, VoidFunctionComponent } from 'react';

import { PolicyType } from '../../types';
import Loader from '../generic/Loader';
import type { AsyncStatus } from '../../types';

type ListLicensePoliciesPageProps = {
  renderPolicyList: (policyType: PolicyType) => ReactNode;
  status: AsyncStatus,
};

const ListLicensePoliciesPage: VoidFunctionComponent<ListLicensePoliciesPageProps> = ({
  status,
  renderPolicyList,
}) => (
  <div className="container margin-top">
    <Helmet title="Policies" />
    {status?.errors?.map(error => <div className="alert alert-error">{error}</div>)}
    {status?.loading ? <Loader /> : renderPolicyList(PolicyType.LICENSING)}
  </div>
);

export default ListLicensePoliciesPage;
